import { RouteConfig } from 'vue-router';
import PView from '../layouts/view.vue';

const mutualRouter: RouteConfig[] = [
  {
    path: '/mutual',
    redirect: '/mutual.html',
    component: PView,
    children: [
      {
        path: '/mutual.html',
        name: 'mutual',
        component: () => import('@/views/mutual/index.vue'),
        meta: { title: '互答空间', parentTab: 'mutual' },
      },
    ],
  },
]
export { mutualRouter }
